var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 4.6665L6.77678 8.4768C7.21756 8.78535 7.43795 8.93962 7.67767 8.99938C7.88943 9.05216 8.1109 9.05216 8.32265 8.99938C8.56238 8.93962 8.78277 8.78535 9.22355 8.4768L14.6668 4.6665M4.5335 13.3332H11.4668C12.5869 13.3332 13.147 13.3332 13.5748 13.1152C13.9511 12.9234 14.2571 12.6175 14.4488 12.2412C14.6668 11.8133 14.6668 11.2533 14.6668 10.1332V5.8665C14.6668 4.7464 14.6668 4.18635 14.4488 3.75852C14.2571 3.3822 13.9511 3.07624 13.5748 2.88449C13.147 2.6665 12.5869 2.6665 11.4668 2.6665H4.5335C3.41339 2.6665 2.85334 2.6665 2.42552 2.88449C2.04919 3.07624 1.74323 3.3822 1.55148 3.75852C1.3335 4.18635 1.3335 4.7464 1.3335 5.8665V10.1332C1.3335 11.2533 1.3335 11.8133 1.55148 12.2412C1.74323 12.6175 2.04919 12.9234 2.42552 13.1152C2.85334 13.3332 3.41339 13.3332 4.5335 13.3332Z",
    stroke: "#667085",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.c589bfb20f6cebfa3d4f7535a646eea4.svg";
export { ForwardRef as ReactComponent };